// src/lib/support_context.client.ts — strângerea contextului tehnic în BROWSER (F14-T2): ascultă
// erorile de client (propriii ascultători — independent de observe.client, care raportează la
// OpenObserve), primește cererile API eșuate de la api.client și compune, la cerere, contextul
// atașat tichetului (`collect_context`). Nimic nu pleacă nicăieri de aici: doar la escaladare, în
// corpul tichetului, prin lista albă din lib/support.

import pkg from "../../package.json"
import { session, session_org_features } from "./session.client"
import { workspace } from "./workspace.client"
import { is_standalone } from "./pwa.client"
import { FEATURE_FLAGS } from "./entitlements"
import {
	build_context,
	push_note,
	type ClientErrorNote,
	type FailedApiNote,
} from "./support_context"
import type { SupportContext } from "./support"

const errors: ClientErrorNote[] = []
const failed: FailedApiNote[] = []
let installed = false

export function install_support_context(): void {
	if (installed || typeof window === "undefined") {
		return
	}
	installed = true
	window.addEventListener("error", (e) => {
		push_note(errors, {
			message: String(e.message || "error"),
			...(e.filename ? { source: `${e.filename}:${e.lineno}` } : {}),
			ts: new Date().toISOString(),
		})
	})
	window.addEventListener("unhandledrejection", (e) => {
		const r = e.reason
		push_note(errors, {
			message: r instanceof Error ? r.message : String(r),
			ts: new Date().toISOString(),
		})
	})
}

/** Apelat de api.client la orice răspuns ≠ ok (status 0 = eroare de rețea). */
export function note_failed_api(method: string, path: string, status: number): void {
	push_note(failed, { method, path, status, ts: new Date().toISOString() })
}

/** Contextul paginii curente — se cheamă în momentul trimiterii tichetului. */
export function collect_context(): SupportContext {
	const s = session.val
	const ws = workspace.val
	const m = s.memberships.length === 1 ? s.memberships[0] : undefined
	const feats = m ? session_org_features(m.org_id) : null
	return build_context({
		route: location.hash.slice(1) || "/",
		map: ws.slug || undefined,
		role: m?.role ?? s.user?.platform_role ?? undefined,
		org_slug: m?.org_slug,
		features_on: feats ? FEATURE_FLAGS.filter((f) => feats[f]) : undefined,
		features_off: feats ? FEATURE_FLAGS.filter((f) => !feats[f]) : undefined,
		app_version: pkg.version,
		ua: navigator.userAgent,
		viewport: `${window.innerWidth}x${window.innerHeight}`,
		online: navigator.onLine,
		standalone: is_standalone(),
		errors,
		failed_api: failed,
	})
}
